var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-screen"},[_c('common-layout',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v("数据大屏")])]),_c('div',{attrs:{"slot":"container"},slot:"container"},[_vm._v(" 数据大屏内容 ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }